export default __webpack_public_path__ + "static/media/DOD.9b70e42a.jpg";